<template>
  <v-card class="mx-auto" rounded flat>
    <v-card-title> Grievance Cases</v-card-title>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="mx-2 mt-n2"
        style="width: 200px"
      ></v-text-field>
      <v-spacer />
      <v-btn class="primary text-capitalize" @click="showDialog = true">
        <v-icon left>mdi-plus</v-icon>
        Raise Case
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="cases"
        :search="search"
        item-key="no"
        show-expand
      >
        <!--eslint-disable-next-line -->
        <template v-slot:item.dateRaised="{ item }">
          <span>{{ item.dateRaised | date }}</span>
          <span>{{ item.dateClosed | date }}</span>
        </template>
        <!--eslint-disable-next-line -->
        <!--eslint-disable-next-line -->
        <template v-slot:item.caseStatus="{ item }">
          <v-chip :class="`${getColor(item.caseStatus)}`" label>
            {{ item.caseStatus }}
          </v-chip>
        </template>
        <!--eslint-disable-next-line -->
        <template v-slot:item.description="{ item }">
          <span class="d-inline-block text-truncate" style="max-width: 150px">
            {{ item.description }}
          </span>
        </template>
        <!--eslint-disable-next-line -->
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-start">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-show="item.caseStatus === 'Open'"
                  class="mx-1"
                  color="blue lighten-4"
                  label
                  small
                  v-bind="attrs"
                  @click="updateCase(item)"
                  v-on="on"
                >
                  <v-icon color="blue darken-4" small>mdi-pencil</v-icon>
                </v-chip>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-show="item.caseStatus === 'Open'"
                  class="mx-1"
                  color="red lighten-4"
                  label
                  small
                  v-bind="attrs"
                  @click="deleteCase(item)"
                  v-on="on"
                >
                  <v-icon color="red darken-4" small>mdi-delete</v-icon>
                </v-chip>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            style="white-space: normal !important; word-break: break-word"
          >
            <strong>Description:</strong> {{ item.description }}<br />
            <strong>Resolution:</strong> {{ item.resolution || "N/A" }}
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <GrievanceCaseForm v-model="showDialog" :record="selectedRecord" />
  </v-card>
</template>
<script>
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";
import { helper } from "@kinetics254/cassandra-base/utilities";
import GrievanceCaseForm from "@/packages/cassandra-grievances/components/GrievanceCaseForm.vue";

export default {
  name: "RaisedList",
  components: { GrievanceCaseForm },
  data() {
    return {
      search: "",
      showDialog: false,
      selectedRecord: null,
    };
  },
  mounted() {
    this.$store.dispatch("Grievances/getGrievanceCases");
  },
  computed: {
    user() {
      return AuthService.user;
    },
    cases() {
      return this.$store.getters["Grievances/grievanceGetters"](
        "grievanceCases"
      );
    },
    headers() {
      return [
        {
          text: "No.",
          value: "no",
          align: "left",
        },
        { text: "Raised On", value: "dateRaised" },
        { text: "Type", value: "caseType" },
        { text: "Status", value: "caseStatus" },
        { text: "Closed On", value: "dateClosed" },
        { text: "actions", value: "action" },
      ];
    },
  },
  methods: {
    getColor(status) {
      return helper.getColor(status).color;
    },
    updateCase(item) {
      this.selectedRecord = item;
      this.showDialog = true;
    },
    deleteCase(item) {
      this.$confirm.show({
        title: `Delete grievance case ${item.no}`,
        text: "Are you sure you want to delete this case?",
        onConfirm: () => {
          this.$store.dispatch("Grievances/deleteCase", item);
        },
      });
    },
  },
};
</script>
